import React, { useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import DepartmentGoalDetail from './DepartmentGoalDetail';
import EmployeeGoalDetail from './EmployeeGoalDetail';
import SupplierGoalDetail from './SupplierGoalDetail';
import AssignGoal from './AssignGoal';
import { Link } from 'react-router-dom';
import Goal from './Goals';
import FormTemplates from './FormTemplates';

const CreateGoal = () => {

    const [selectedOption, setSelectedOption] = useState('');

    const { data, isLoading } = useFetch(`templates`);


    if (isLoading) {
        return (
            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2 py-2">
                        <i className="fa-solid fa-spinner fa-spin"></i>
                    </h1>
                </div>
            </main>
        );
    }


    const handleChange = (e) => {
        setSelectedOption(e.target.value);
    };

    return (

        <>


            <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h1 className="h2">
                        <Link to="/overview" >
                            <i className="fa-solid fa-arrow-left"></i>
                        </Link>
                        Create Goal
                    </h1>

                </div>

                <div className='col-md-12'>
                    <div className="selecttemp">
                    <h4>Select Templates</h4>
                    <select className='form-select' value={selectedOption} onChange={handleChange}>
                        <option value="" disabled hidden>
                            
                            Choose an option
                        </option>
                        {data && data.length > 0 ? (
                            data.map((val) => (
                                <option  key={val.id} value={val.id}>
                                    {val.template_name}
                                </option>
                            ))
                        ) : (
                            <option className='mt-2' disabled>No Employee data available.</option>
                        )}
                    </select>
                    </div>

                <FormTemplates selectedOption={selectedOption} />
                </div>
            </main>

        </>


    );
};

export default CreateGoal;
